import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {CompWithWorkingProps} from 'common/src/modules/movieEditor/movieEditor.types';
import updateComps from './updateComps';
import {RootState} from 'common/src/redux/store';

interface UpdateCompParams {
  data: Partial<CompWithWorkingProps>;
  activeFormat?: string;
}

const updateActiveComp = createAsyncThunk(
  `${BreadcrumbName.AdBuilder}/updateComp`,
  async ({data, activeFormat}: UpdateCompParams, {dispatch, getState}): Promise<void> => {
    const state = getState() as RootState;
    const activeCompId = state.creativeTemplatePage.formatMovies.activeCompId;
    await dispatch(
      updateComps({
        compsUpdate: (oldComps) => ({
          ...oldComps,
          [activeCompId]: {
            ...oldComps[activeCompId],
            ...data,
          },
        }),
        activeFormat,
        replaceState: false,
      }),
    );
  },
);

export default updateActiveComp;
